<template>
  <SocioSnackbar
    v-model="visible"
    :color="type === 'success' ? 'success' : 'error'"
    location="top"
    :timeout="timeout"
  >
    <div v-if="title" class="text-subtitle-2 font-weight-medium">
      {{ title }}
    </div>
    <div v-if="text" class="text-body-2">{{ text }}</div>
  </SocioSnackbar>
</template>

<script setup>
  import { storeToRefs } from "pinia";
  import { useSnackbarStore } from "@/store/snackbar.js";

  const { visible, title, text, type, timeout } =
    storeToRefs(useSnackbarStore());
</script>
